import type { SkillMenuItem } from "~/atoms/chatbot";

/** Cap on rows rendered in the slash menu — anything beyond is noise. */
const MENU_RESULT_LIMIT = 10;

/**
 * Case-insensitive substring match on a skill's name and description. Empty
 * query returns every skill (up to the limit). Used by the slash menu to
 * filter as the user types `/<query>`.
 *
 * Skill names are kebab-case (lowercase) by spec, but we still lowercase both
 * sides so a future uppercase typo or schema relaxation can't silently miss.
 */
export function filterSkills(
  skills: SkillMenuItem[],
  query: string,
): SkillMenuItem[] {
  if (!query) return skills.slice(0, MENU_RESULT_LIMIT);
  const lc = query.toLowerCase();
  return skills
    .filter(
      (s) =>
        s.name.toLowerCase().includes(lc) ||
        (s.description ?? "").toLowerCase().includes(lc),
    )
    .slice(0, MENU_RESULT_LIMIT);
}
